import { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { editorStore } from "../../store/editorStore";
import { floorplannerStore } from "../../store/floorplannerStore";
import { HiOutlinePlus, HiChevronDown } from "react-icons/hi";
import boniLogo from "../../../src/assets/newlogo.svg";
import React from 'react';
import { SymbolsPanel } from "./SymbolsPanel";
import { BsLayoutSidebar } from "react-icons/bs";
import { FiLayout } from "react-icons/fi";
import { FaRegCircle, FaRegHeart } from "react-icons/fa";
import { PiRuler } from "react-icons/pi";
import { PiWall } from "react-icons/pi";
import { TbSofa } from "react-icons/tb";
import { FiBox, FiImage, FiUploadCloud, FiUsers } from "react-icons/fi";
import { LuLayoutTemplate } from "react-icons/lu";
import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { TemplatesPanel } from "./TemnplatesPanel";
import { WallsPanel } from "./WallsPanel";
import { MeasurePanel } from "./MeasurePanel";
import { renderStore } from "../../store/renderStore";
import { Scene } from "three";
import { useThree } from "@react-three/fiber";
import { ShapesPanel } from "./ShapesPanel";
import { UploadsPanel } from "./UploadsPanel";
import { BackdropImageModal } from "./BackdropImageModal";
import { CreateModel3DFromImageModal } from "./CreateModel3DFromImageModal";
import { UserModels3DPanel } from "./UserModels3DPanel";
import {
  ProductLibraryPanel,
  type LibrarySource,
} from "./ProductLibraryPanel";
import { FavoritesPanel } from "./FavoritesPanel";
import { LanguageSelector } from "../LanguageSelector";
import { CurrencySelector } from "../CurrencySelector";
import { FloorplanImageImportModal } from "./FloorplanImageImportModal";
import { DisplayLengthUnitToggle } from "../DisplayLengthUnitToggle";

const LeftPanel = observer(() => {
  const { t } = useTranslation();
  //For Templets
  const [isTemplatesPanelVisible, setTemplatesPanelVisible] = useState(false);
  const [templatesPanelPosition, setTemplatesPanelPosition] = useState({ top: 0, left: 0 });
  const templatesPanelRef = useRef<HTMLDivElement>(null);
  const templatesInitiatorRef = useRef<HTMLDivElement>(null);

  // For Shapes
  const [isShapesPanelVisible, setShapesPanelVisible] = useState(false);
  const [shapesPanelPosition, setShapesPanelPosition] = useState({ top: 0, left: 0 });
  const shapesPanelRef = useRef<HTMLDivElement>(null);
  const shapeInitiatorRef = useRef<HTMLDivElement>(null);

  // For Symbols
  const [isSymbolsPanelVisible, setSymbolsPanelVisible] = useState(false);
  const [symbolsPanelPosition, setSymbolsPanelPosition] = useState({ top: 0, left: 0 });
  const symbolsPanelRef = useRef<HTMLDivElement>(null);
  const symbolInitiatorRef = useRef<HTMLDivElement>(null);

  // For Walls
  const [isWallsPanelVisible, setWallsPanelVisible] = useState(false);
  const [wallsPanelPosition, setWallsPanelPosition] = useState({ top: 0, left: 0 });
  const wallsPanelRef = useRef<HTMLDivElement>(null);
  const wallInitiatorRef = useRef<HTMLDivElement>(null);
  // For Measure & Tools
  const [isMeasurePanelVisible, setMeasurePanelVisible] = useState(false);
  const [measurePanelPosition, setMeasurePanelPosition] = useState({ top: 0, left: 0 });
  const measurePanelRef = useRef<HTMLDivElement>(null);
  const measureInitiatorRef = useRef<HTMLDivElement>(null);

  // For Uploads
  const [isUploadsPanelVisible, setUploadsPanelVisible] = useState(false);
  const [uploadsPanelPosition, setUploadsPanelPosition] = useState({ top: 0, left: 0 });
  const uploadsPanelRef = useRef<HTMLDivElement>(null);
  const uploadInitiatorRef = useRef<HTMLDivElement>(null);
  const [isUserModels3DPanelVisible, setUserModels3DPanelVisible] = useState(false);
  const [userModels3DPanelPosition, setUserModels3DPanelPosition] = useState({ top: 0, left: 0 });
  const userModels3DPanelRef = useRef<HTMLDivElement>(null);
  const userModels3DInitiatorRef = useRef<HTMLDivElement>(null);
  const [isBackdropModalOpen, setBackdropModalOpen] = useState(false);
  const [isImageImportModalOpen, setImageImportModalOpen] = useState(false);
  const [imageImportId, setImageImportId] = useState<string | undefined>();
  const [isCreateModel3DFromImageOpen, setCreateModel3DFromImageOpen] =
    useState(false);
  const [isProductLibraryVisible, setProductLibraryVisible] = useState(false);
  const [productLibrarySource, setProductLibrarySource] =
    useState<LibrarySource>("BONI");
  const [productLibraryPosition, setProductLibraryPosition] = useState({ top: 16, left: 252 });
  const productLibraryRef = useRef<HTMLDivElement>(null);
  const productLibraryInitiatorRef = useRef<HTMLDivElement>(null);
  const communityLibraryInitiatorRef = useRef<HTMLDivElement>(null);
  const [isFavoritesPanelVisible, setFavoritesPanelVisible] = useState(false);
  const [favoritesPanelPosition, setFavoritesPanelPosition] = useState({
    top: 16,
    left: 252,
  });
  const favoritesPanelRef = useRef<HTMLDivElement>(null);
  const favoritesInitiatorRef = useRef<HTMLDivElement>(null);

  const [systemMenuOpen, setSystemMenuOpen] = useState(false);
  const systemMenuRef = useRef<HTMLDivElement | null>(null);

  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState(floorplannerStore.name);

  // Open Image Trace when arriving from MyPage with ?imageTrace=1
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("imageTrace") !== "1") return;
    params.delete("imageTrace");
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", nextUrl);
    // View-only collaborators cannot insert; skip opening the import modal.
    if (floorplannerStore.lockedByOther || floorplannerStore.collabAccessLost) {
      return;
    }
    setImageImportId(undefined);
    setImageImportModalOpen(true);
  }, []);

  const handleNameClick = () => {
    if (floorplannerStore.lockedByOther) return;
    const current = floorplannerStore.name.trim();
    setNewName(
      !current || current === "Untitled" ? t("common.untitled") : floorplannerStore.name,
    );
    setIsEditing(true);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewName(e.target.value);
  };

  const handleBlurOrSubmit = () => {
    const trimmed = newName.trim();
    const nextName =
      !trimmed || trimmed === t("common.untitled") ? "Untitled" : trimmed;
    floorplannerStore.setName(nextName);
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleBlurOrSubmit();
    }
  };


  const openShapesPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const panelHeight = 450;
    // Make sure that we have enough space to show the panel below the initiator otherwise move it up by the difference
    if (rect.top + panelHeight > window.innerHeight) {
      setShapesPanelPosition({
        top: rect.top + window.scrollY - 150,
        left: rect.right + window.scrollX,
      });
    } else {
      setShapesPanelPosition({
        top: rect.top + window.scrollY,
        left: rect.right + window.scrollX,
      });
    }
    setShapesPanelVisible(true);
  };

  const closeShapesPanel = () => {
    setShapesPanelVisible(false);
  };

  const openUploadsPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    // Tall list (previous backgrounds) — bias open position upward so the panel
    // fits in the viewport; UploadsPanel also clamps top/maxHeight on resize.
    const viewportGap = 12;
    const estimatedPanelHeight = Math.min(
      Math.round(window.innerHeight * 0.7),
      window.innerHeight - viewportGap * 2,
    );
    const preferredTop = rect.top + window.scrollY;
    const maxTop = Math.max(
      viewportGap,
      window.innerHeight - viewportGap - estimatedPanelHeight,
    );
    setUploadsPanelPosition({
      top: Math.min(preferredTop, maxTop),
      left: rect.right + window.scrollX,
    });
    setUploadsPanelVisible(true);
  };

  const closeUploadsPanel = () => {
    setUploadsPanelVisible(false);
  };

  const openUserModels3DPanel = (event: {
    currentTarget: HTMLDivElement;
  }) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const panelHeight = 320;
    setUserModels3DPanelPosition({
      top: rect.top + panelHeight > window.innerHeight ? rect.top + window.scrollY - 160 : rect.top + window.scrollY,
      left: rect.right + window.scrollX,
    });
    setUserModels3DPanelVisible(true);
  };

  const closeUserModels3DPanel = () => {
    setUserModels3DPanelVisible(false);
  };

  const closeFavoritesPanel = () => {
    setFavoritesPanelVisible(false);
    window.requestAnimationFrame(() => {
      favoritesInitiatorRef.current?.focus();
    });
  };

  const closeProductLibrary = () => {
    setProductLibraryVisible(false);
    window.requestAnimationFrame(() => {
      const focusTarget =
        productLibrarySource === "USERS"
          ? communityLibraryInitiatorRef.current
          : productLibraryInitiatorRef.current;
      focusTarget?.focus();
    });
  };

  const openProductLibrary = (
    event: { currentTarget: HTMLDivElement },
    source?: LibrarySource,
  ) => {
    setFavoritesPanelVisible(false);
    const rect = event.currentTarget.getBoundingClientRect();
    setProductLibraryPosition({
      top: 16,
      left: Math.round(rect.right + 8),
    });
    if (source) {
      setProductLibrarySource(source);
    }
    setProductLibraryVisible(true);
  };

  const openFavoritesPanel = (event: {
    currentTarget: HTMLDivElement;
  }) => {
    setProductLibraryVisible(false);
    const rect = event.currentTarget.getBoundingClientRect();
    setFavoritesPanelPosition({
      top: 16,
      left: Math.round(rect.right + 8),
    });
    setFavoritesPanelVisible(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If click target is outside the SymbolsPanel and not the initiator
      if (
        shapesPanelRef.current &&
        !shapesPanelRef.current.contains(event.target as Node) &&
        shapeInitiatorRef.current &&
        !shapeInitiatorRef.current.contains(event.target as Node)
      ) {
        closeShapesPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [shapesPanelRef, shapeInitiatorRef]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        uploadsPanelRef.current &&
        !uploadsPanelRef.current.contains(event.target as Node) &&
        uploadInitiatorRef.current &&
        !uploadInitiatorRef.current.contains(event.target as Node)
      ) {
        closeUploadsPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [uploadsPanelRef, uploadInitiatorRef]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        (event.target as Element | null)?.closest?.(
          "[data-user-model-3d-edit-modal]",
        )
      ) {
        return;
      }
      if (
        userModels3DPanelRef.current &&
        !userModels3DPanelRef.current.contains(event.target as Node) &&
        userModels3DInitiatorRef.current &&
        !userModels3DInitiatorRef.current.contains(event.target as Node)
      ) {
        closeUserModels3DPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userModels3DPanelRef, userModels3DInitiatorRef]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element | null;
      if (target?.closest?.("[data-product-library-modal]")) return;
      const clickedProductLibraryInitiator =
        productLibraryInitiatorRef.current?.contains(event.target as Node);
      const clickedCommunityLibraryInitiator =
        communityLibraryInitiatorRef.current?.contains(event.target as Node);
      if (
        productLibraryRef.current &&
        !productLibraryRef.current.contains(event.target as Node) &&
        !clickedProductLibraryInitiator &&
        !clickedCommunityLibraryInitiator
      ) {
        closeProductLibrary();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element | null;
      if (target?.closest?.("[data-product-library-modal]")) return;
      if (
        favoritesPanelRef.current &&
        !favoritesPanelRef.current.contains(event.target as Node) &&
        !favoritesInitiatorRef.current?.contains(event.target as Node)
      ) {
        closeFavoritesPanel();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const openSymbolsPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const panelHeight = 450;
    // Make sure that we have enough space to show the panel below the initiator otherwise move it up by the difference
    if (rect.top + panelHeight > window.innerHeight) {
      setSymbolsPanelPosition({
        top: rect.top + window.scrollY - 200,
        left: rect.right + window.scrollX,
      });
    } else {
      setSymbolsPanelPosition({
        top: rect.top + window.scrollY,
        left: rect.right + window.scrollX,
      });
    }
    setSymbolsPanelVisible(true);
  };

  const closeSymbolsPanel = () => {
    setSymbolsPanelVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If click target is outside the SymbolsPanel and not the initiator
      if (
        symbolsPanelRef.current &&
        !symbolsPanelRef.current.contains(event.target as Node) &&
        symbolInitiatorRef.current &&
        !symbolInitiatorRef.current.contains(event.target as Node)
      ) {
        closeSymbolsPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [symbolsPanelRef, symbolInitiatorRef]);

  const openWallsPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    setWallsPanelPosition({
      top: rect.top + window.scrollY,
      left: rect.right + window.scrollX,
    });
    setWallsPanelVisible(true);
  };

  const closeWallsPanel = () => {
    setWallsPanelVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If click target is outside the SymbolsPanel and not the initiator
      if (
        wallsPanelRef.current &&
        !wallsPanelRef.current.contains(event.target as Node) &&
        wallInitiatorRef.current &&
        !wallInitiatorRef.current.contains(event.target as Node)
      ) {
        closeWallsPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wallsPanelRef, wallInitiatorRef]);

  const openMeasurePanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    setMeasurePanelPosition({
      top: rect.top + window.scrollY,
      left: rect.right + window.scrollX,
    });
    setMeasurePanelVisible(true);
  };

  const closeMeasurePanel = () => {
    setMeasurePanelVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If click target is outside the SymbolsPanel and not the initiator
      if (
        measurePanelRef.current &&
        !measurePanelRef.current.contains(event.target as Node) &&
        measureInitiatorRef.current &&
        !measureInitiatorRef.current.contains(event.target as Node)
      ) {
        closeMeasurePanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [measurePanelRef, measureInitiatorRef]);


  const openTemplatesPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    setTemplatesPanelPosition({
      top: rect.top + window.scrollY,
      left: rect.right + window.scrollX,
    });
    setTemplatesPanelVisible(true);
  };

  const closeTemplatesPanel = () => {
    setTemplatesPanelVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If click target is outside the TemplatesPanel and not the initiator
      if (
        templatesPanelRef.current &&
        !templatesPanelRef.current.contains(event.target as Node) &&
        templatesInitiatorRef.current &&
        !templatesInitiatorRef.current.contains(event.target as Node)
      ) {
        closeTemplatesPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [templatesPanelRef, templatesInitiatorRef]);


  // Handle click outside systemMenu to close it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (systemMenuRef.current && !systemMenuRef.current.contains(event.target as Node)) {
        setSystemMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [systemMenuRef]);

  useEffect(() => {
    setNewName(floorplannerStore.name);
  }, [floorplannerStore.name]);

  useEffect(() => {
    if (editorStore.view3D && isWallsPanelVisible) {
      closeWallsPanel();
    }
  }, [editorStore.view3D, isWallsPanelVisible]);

  // Open Product Library when requested from elsewhere (e.g. empty Product List CTA).
  useEffect(() => {
    if (editorStore.productLibraryOpenRequest === 0) return;
    if (floorplannerStore.isInitializing) return;
    const initiator = productLibraryInitiatorRef.current;
    if (initiator) {
      openProductLibrary({ currentTarget: initiator });
      return;
    }
    setFavoritesPanelVisible(false);
    setProductLibraryPosition({ top: 16, left: 252 });
    setProductLibraryVisible(true);
  }, [editorStore.productLibraryOpenRequest]);

  const TitleEditBox = () => {
    return (
      <>
        {/* Floorplan title edit box */}
        < div className="relative inline-flex w-full items-left rounded-sm p-3 pt-0 cursor-text" >
          {
            isEditing ? (
              <input
                type="text"
                value={newName}
                onChange={handleNameChange}
                onBlur={handleBlurOrSubmit}
                onKeyDown={handleKeyDown}
                autoFocus
                className="w-full h-full text-zinc-950 font-['DM Sans'] text-sm font-normal bg-stone-100 border-none outline-none"
                style={{ boxSizing: "border-box" }} // Ensures padding and borders are considered in width calculation
              />
            ) : (
              <div
                className="text-zinc-950 font-['DM Sans'] text-sm font-medium cursor-pointer text-ellipsis overflow-hidden whitespace-nowrap"
                onClick={handleNameClick}
                style={{ boxSizing: "border-box" }}
              >
                {floorplannerStore.name === "Untitled" || !floorplannerStore.name.trim()
                  ? t("common.untitled")
                  : floorplannerStore.name}
                {floorplannerStore.isShared && (
                  <span className="ml-1 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800">
                    {t("leftPanel.shared")}
                  </span>
                )}
              </div>
            )}
        </div >
      </>
    );
  }


  return (
    <div
      className="sidebar-left select-none flex flex-col items-left justify-start gap-1"
      onPointerDown={() => editorStore.stopPanningForToolInteraction()}
      onClick={(event) => event.stopPropagation()} // Prevent clicks inside the sidebar from affecting SymbolsPanel visibility
    >
      {/* Logo section */}
      <div className="flex items-col justify-between pb-2">
        <div
          className="flex items-center ml-3 mt-3 cursor-pointer"
          onClick={() => setSystemMenuOpen(!systemMenuOpen)}
          ref={systemMenuRef}
        >
          <div
            className="flex items-center bg-bonigold"
            style={{ width: 34, height: 34 }}
          >
            <img
              src={boniLogo}
              alt="boni logo black"
              className="w-6 lg:w-12"
              style={{ width: 34 }}
            />
          </div>
          <HiChevronDown className="h-4 w-4" />
          {/* System Menu */}
          {systemMenuOpen && (
            <div className="fixed left-10 top-16 w-36 bg-black text-white border border-gray-300 shadow-lg rounded-lg py-2 z-20">
              <div
                className="px-4 py-2 cursor-pointer flex items-center justify-center gap-2 flex-row hover:bg-[#66645F]"
                onClick={async () => {
                  if (editorStore.camera) {
                    await renderStore.captureSnapshot('upload', undefined, undefined, editorStore.camera);
                  }
                  window.parent.location.href = process.env.REACT_APP_CLIENT_URI + "/mypage/projects/myprojects";
                }}
              >
                {t("leftPanel.myPage")}
              </div>
              <div className="border-b border-[#66645F]" />
              <div
                className="px-4 py-2 cursor-pointer flex items-center justify-center gap-2 flex-row hover:bg-[#66645F]"
                onClick={async () => {
                  if (editorStore.camera) {
                    await renderStore.captureSnapshot('upload', undefined, undefined, editorStore.camera);
                  }
                  window.parent.location.href = process.env.REACT_APP_CLIENT_URI + "/search-products";
                }}
              >
                {t("leftPanel.products")}
              </div>
              <div className="border-b border-[#66645F]" />
              <div
                className="px-4 py-2 cursor-pointer flex items-center justify-center gap-2 flex-row hover:bg-[#66645F]"
                onClick={async () => {
                  if (editorStore.camera) {
                    await renderStore.captureSnapshot('upload', undefined, undefined, editorStore.camera);
                  }
                  window.parent.location.href = process.env.REACT_APP_CLIENT_URI + "/gallery";
                }}
              >
                {t("leftPanel.gallery")}
              </div>
              <div className="border-b border-[#66645F]" />
              <div
                className="px-4 py-2 cursor-pointer flex items-center justify-center gap-2 flex-row hover:bg-[#66645F]"
                onClick={async () => {
                  if (editorStore.camera) {
                    await renderStore.captureSnapshot('upload', undefined, undefined, editorStore.camera);
                  }
                  window.parent.location.href = process.env.REACT_APP_CLIENT_URI + "/designers";
                }}
              >
                {t("leftPanel.designers")}
              </div>
              <div className="border-b border-[#66645F]" />
              <div
                className="px-4 py-2 cursor-pointer flex items-center justify-center gap-2 flex-row hover:bg-[#66645F]"
                onClick={async () => {
                  if (editorStore.camera) {
                    await renderStore.captureSnapshot('upload', undefined, undefined, editorStore.camera);
                  }
                  window.parent.location.href = process.env.REACT_APP_CLIENT_URI + "/tutorials";
                }}
              >
                {t("leftPanel.tutorials")}
              </div>
            </div>
          )}
        </div>
        {/* Collapses only the left toolbox — property panel has its own control */}
        <Tooltip content={editorStore.minimized ? t("common.maximize") : t("common.minimize")} placement="bottom">
          <div
            className={`flex items-center mr-3 mt-2 cursor-pointer`}
            onClick={() => editorStore.setMinimized(!editorStore.minimized)}
            aria-label={editorStore.minimized ? t("common.maximize") : t("common.minimize")}
          >
            <div className={`flex items-center justify-center rounded-sm w-[24px] h-[24px] ${editorStore.minimized ? " bg-eggshell300" : ""}`}>
              <BsLayoutSidebar style={{ strokeWidth: 0.5 }} />
            </div>
          </div>
        </Tooltip>
      </div>

      {!editorStore.minimized && (
        <>
          <TitleEditBox />
          {/* Divider line 100% width */}
          <div className="border-b border-stone-200 w-full" />
          {/* Links */}
          <div className="font-dm text-xs font-normal text-black p-1 pt-1 mb-2">
            {/* Elements */}
            <div className="inline-flex w-full flex-col items-start justify-start gap-2 p-2 pb-1 text-[11px] uppercase tracking-wide text-gray-500">
              {t("leftPanel.buildingBlocks")}
            </div>
            {/* <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 cursor-pointer ${isTemplatesPanelVisible ? "bg-eggshell100" : ""}`}
              onClick={isTemplatesPanelVisible ? closeTemplatesPanel : openTemplatesPanel}
              ref={templatesInitiatorRef} // Ref for the initiator
            >
              <FiLayout style={{ strokeWidth: 2 }} size={19} />
              Floorplan templates
              {isTemplatesPanelVisible && (
                <TemplatesPanel
                  position={templatesPanelPosition}
                  onClose={closeTemplatesPanel}
                  dropdownRef={templatesPanelRef}
                />
              )}
            </div> */}
            <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${
                floorplannerStore.isInitializing || editorStore.view3D
                  ? `${editorStore.view3D ? "opacity-40 cursor-not-allowed" : "opacity-50"} pointer-events-none`
                  : "cursor-pointer"
              } ${isWallsPanelVisible ? "bg-eggshell100" : ""}`}
              onClick={
                editorStore.view3D
                  ? undefined
                  : isWallsPanelVisible
                    ? closeWallsPanel
                    : openWallsPanel
              }
              ref={wallInitiatorRef} // Ref for the initiator
              aria-disabled={editorStore.view3D}
              title={editorStore.view3D ? t("common.unavailableIn3DView") : undefined}
            >
              <PiWall style={{ strokeWidth: 2 }} size={19} />
              {t("panels.structures")}
              {/* WallsPanel (Structures) — 2D only */}
              {isWallsPanelVisible && !editorStore.view3D && (
                <WallsPanel
                  position={wallsPanelPosition}
                  onClose={closeWallsPanel}
                  dropdownRef={wallsPanelRef}
                />
              )}
            </div>
            <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isShapesPanelVisible ? "bg-eggshell100" : ""}`}
              onClick={isShapesPanelVisible ? closeShapesPanel : openShapesPanel}
              ref={shapeInitiatorRef} // Ref for the initiator
            >
              <FaRegCircle style={{ strokeWidth: 2 }} size={19} />
              {t("panels.shapes")}
              {/* ShapesPanel */}
              {isShapesPanelVisible && (
                <ShapesPanel
                  position={shapesPanelPosition}
                  onClose={closeShapesPanel}
                  dropdownRef={shapesPanelRef}
                />
              )}
            </div>
            <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isSymbolsPanelVisible ? "bg-eggshell100" : ""}`}
              onClick={isSymbolsPanelVisible ? closeSymbolsPanel : openSymbolsPanel}
              ref={symbolInitiatorRef} // Ref for the initiator
            >
              <TbSofa style={{ strokeWidth: 2 }} size={19} />
              {t("panels.symbols")}
              {/* SymbolsPanel */}
              {isSymbolsPanelVisible && (
                <SymbolsPanel
                  position={symbolsPanelPosition}
                  onClose={closeSymbolsPanel}
                  dropdownRef={symbolsPanelRef}
                />
              )}
            </div>
            <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isMeasurePanelVisible ? "bg-eggshell100" : ""}`}
              onClick={isMeasurePanelVisible ? closeMeasurePanel : openMeasurePanel}
              ref={measureInitiatorRef} // Ref for the initiator
            >
              <PiRuler style={{ strokeWidth: 2 }} size={19} />
              {t("panels.measuringTools")}
              {/* MeasurePanel */}
              {isMeasurePanelVisible && (
                <MeasurePanel
                  position={measurePanelPosition}
                  onClose={closeMeasurePanel}
                  dropdownRef={measurePanelRef}
                />
              )}
            </div>
            <div
              className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}`}
              onClick={() => {
                if (floorplannerStore.isInitializing) return;
                closeMeasurePanel();
                editorStore.openRoomPicker();
              }}
              role="button"
              tabIndex={floorplannerStore.isInitializing ? -1 : 0}
              onKeyDown={(event) => {
                if (floorplannerStore.isInitializing) return;
                if (event.key !== "Enter" && event.key !== " ") return;
                event.preventDefault();
                closeMeasurePanel();
                editorStore.openRoomPicker();
              }}
              title={t("measure.addRoom")}
            >
              <LuLayoutTemplate style={{ strokeWidth: 2 }} size={19} />
              {t("measure.addRoom")}
            </div>
            <div className="mt-3 border-t border-stone-200 pt-3">
              <div className="inline-flex w-full flex-col items-start justify-start gap-2 p-2 pb-1 text-[11px] uppercase tracking-wide text-gray-500">
                {t("leftPanel.productLibrary")}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'pointer-events-none opacity-50' : 'cursor-pointer'} ${isProductLibraryVisible && productLibrarySource !== "USERS" ? "bg-eggshell100" : ""}`}
                onClick={(event) => {
                  if (floorplannerStore.isInitializing) return;
                  // Catalog entry: toggle when already on BONI/BRAND; otherwise open catalog
                  // (including when Community/USERS is currently showing).
                  if (
                    isProductLibraryVisible &&
                    productLibrarySource !== "USERS"
                  ) {
                    closeProductLibrary();
                    return;
                  }
                  const catalogSource =
                    productLibrarySource === "USERS"
                      ? "BONI"
                      : productLibrarySource;
                  openProductLibrary(event, catalogSource);
                }}
                onKeyDown={(event) => {
                  if (
                    event.target !== event.currentTarget ||
                    floorplannerStore.isInitializing
                  ) {
                    return;
                  }
                  if (event.key !== "Enter" && event.key !== " ") return;
                  event.preventDefault();
                  if (
                    isProductLibraryVisible &&
                    productLibrarySource !== "USERS"
                  ) {
                    closeProductLibrary();
                    return;
                  }
                  const catalogSource =
                    productLibrarySource === "USERS"
                      ? "BONI"
                      : productLibrarySource;
                  openProductLibrary(event, catalogSource);
                }}
                role="button"
                tabIndex={floorplannerStore.isInitializing ? -1 : 0}
                aria-disabled={floorplannerStore.isInitializing}
                aria-expanded={
                  isProductLibraryVisible && productLibrarySource !== "USERS"
                }
                aria-haspopup="dialog"
                ref={productLibraryInitiatorRef}
              >
                <TbSofa style={{ strokeWidth: 2 }} size={19} />
                {t("leftPanel.productLibrary")}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'pointer-events-none opacity-50' : 'cursor-pointer'} ${isProductLibraryVisible && productLibrarySource === "USERS" ? "bg-eggshell100" : ""}`}
                onClick={(event) => {
                  if (floorplannerStore.isInitializing) return;
                  if (
                    isProductLibraryVisible &&
                    productLibrarySource === "USERS"
                  ) {
                    closeProductLibrary();
                  } else {
                    openProductLibrary(event, "USERS");
                  }
                }}
                onKeyDown={(event) => {
                  if (
                    event.target !== event.currentTarget ||
                    floorplannerStore.isInitializing
                  ) {
                    return;
                  }
                  if (event.key !== "Enter" && event.key !== " ") return;
                  event.preventDefault();
                  if (
                    isProductLibraryVisible &&
                    productLibrarySource === "USERS"
                  ) {
                    closeProductLibrary();
                  } else {
                    openProductLibrary(event, "USERS");
                  }
                }}
                role="button"
                tabIndex={floorplannerStore.isInitializing ? -1 : 0}
                aria-disabled={floorplannerStore.isInitializing}
                aria-expanded={
                  isProductLibraryVisible && productLibrarySource === "USERS"
                }
                aria-haspopup="dialog"
                ref={communityLibraryInitiatorRef}
              >
                <FiUsers style={{ strokeWidth: 2 }} size={19} />
                {t("leftPanel.community3DLibrary")}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'pointer-events-none opacity-50' : 'cursor-pointer'} ${isFavoritesPanelVisible ? "bg-eggshell100" : ""}`}
                onClick={(event) => {
                  if (floorplannerStore.isInitializing) return;
                  if (isFavoritesPanelVisible) {
                    closeFavoritesPanel();
                  } else {
                    openFavoritesPanel(event);
                  }
                }}
                onKeyDown={(event) => {
                  if (
                    event.target !== event.currentTarget ||
                    floorplannerStore.isInitializing
                  ) {
                    return;
                  }
                  if (event.key !== "Enter" && event.key !== " ") return;
                  event.preventDefault();
                  if (isFavoritesPanelVisible) {
                    closeFavoritesPanel();
                  } else {
                    openFavoritesPanel(event);
                  }
                }}
                role="button"
                tabIndex={floorplannerStore.isInitializing ? -1 : 0}
                aria-disabled={floorplannerStore.isInitializing}
                aria-expanded={isFavoritesPanelVisible}
                aria-haspopup="dialog"
                ref={favoritesInitiatorRef}
              >
                <FaRegHeart style={{ strokeWidth: 2 }} size={18} />
                {t("leftPanel.myFavorites")}
              </div>
              {isProductLibraryVisible && (
                <ProductLibraryPanel
                  position={productLibraryPosition}
                  onClose={closeProductLibrary}
                  dropdownRef={productLibraryRef}
                  selectedSource={productLibrarySource}
                  onSourceChange={setProductLibrarySource}
                />
              )}
              {isFavoritesPanelVisible && (
                <FavoritesPanel
                  position={favoritesPanelPosition}
                  onClose={closeFavoritesPanel}
                  dropdownRef={favoritesPanelRef}
                />
              )}
            </div>
            <div className="mt-3 border-t border-stone-200 pt-3">
              <div className="inline-flex w-full flex-col items-start justify-start gap-2 p-2 pb-1 text-[11px] uppercase tracking-wide text-gray-500">
                {t("leftPanel.personalAssets")}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isUploadsPanelVisible ? "bg-eggshell100" : ""}`}
                onClick={isUploadsPanelVisible ? closeUploadsPanel : openUploadsPanel}
                ref={uploadInitiatorRef}
              >
                <FiUploadCloud style={{ strokeWidth: 2 }} size={19} />
                {t("leftPanel.backgroundImages")}
                {isUploadsPanelVisible && (
                  <UploadsPanel
                    position={uploadsPanelPosition}
                    onClose={closeUploadsPanel}
                    dropdownRef={uploadsPanelRef}
                    onAddBackgroundImage={() => {
                      closeUploadsPanel();
                      setBackdropModalOpen(true);
                    }}
                    onCreateEditableDrawing={() => {
                      closeUploadsPanel();
                      setImageImportId(undefined);
                      setImageImportModalOpen(true);
                    }}
                    onOpenImageImport={(id) => {
                      closeUploadsPanel();
                      setImageImportId(id);
                      setImageImportModalOpen(true);
                    }}
                  />
                )}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isUserModels3DPanelVisible ? "bg-eggshell100" : ""}`}
                onClick={isUserModels3DPanelVisible ? closeUserModels3DPanel : openUserModels3DPanel}
                ref={userModels3DInitiatorRef}
              >
                <FiBox style={{ strokeWidth: 2 }} size={19} />
                {t("productLibrary.title")}
                {isUserModels3DPanelVisible && (
                  <UserModels3DPanel
                    position={userModels3DPanelPosition}
                    onClose={closeUserModels3DPanel}
                    dropdownRef={userModels3DPanelRef}
                  />
                )}
              </div>
              <div
                className={`inline-flex w-full flex-rows items-center justify-start gap-2 p-2 ${floorplannerStore.isInitializing ? 'opacity-50 pointer-events-none' : 'cursor-pointer'} ${isCreateModel3DFromImageOpen ? "bg-eggshell100" : ""}`}
                onClick={() => {
                  if (floorplannerStore.isInitializing) return;
                  setCreateModel3DFromImageOpen(true);
                }}
                onKeyDown={(event) => {
                  if (floorplannerStore.isInitializing) return;
                  if (event.key !== "Enter" && event.key !== " ") return;
                  event.preventDefault();
                  setCreateModel3DFromImageOpen(true);
                }}
                role="button"
                tabIndex={floorplannerStore.isInitializing ? -1 : 0}
                aria-disabled={floorplannerStore.isInitializing}
              >
                <FiImage style={{ strokeWidth: 2 }} size={19} />
                {t("leftPanel.create3DObjectFromImage")}
              </div>
            </div>
            <BackdropImageModal
              isOpen={isBackdropModalOpen}
              mode="add"
              onClose={() => setBackdropModalOpen(false)}
            />
            <FloorplanImageImportModal
              isOpen={isImageImportModalOpen}
              importId={imageImportId}
              onClose={() => setImageImportModalOpen(false)}
            />
            {isCreateModel3DFromImageOpen && (
              <CreateModel3DFromImageModal
                onClose={() => setCreateModel3DFromImageOpen(false)}
                onGenerated={() => {
                  setCreateModel3DFromImageOpen(false);
                  const initiator = userModels3DInitiatorRef.current;
                  if (initiator) {
                    openUserModels3DPanel({ currentTarget: initiator });
                  } else {
                    setUserModels3DPanelVisible(true);
                  }
                }}
              />
            )}
          </div>
        </>
      )}

      <div className="mt-auto flex items-center gap-2 px-2 py-2">
        <LanguageSelector compact />
        <CurrencySelector compact />
        <DisplayLengthUnitToggle />
      </div>

    </div>
  );
});

export default LeftPanel;
